export default "__VITE_ASSET__BYULW1tz__"